<template>
    <nav class="-ml-2 -mr-2 bg-grey-100 flex items-center justify-start p-2 rounded-xl mobile:p-1.5 relative z-0 border border-grey-transparent-200">
       <div class="tablet:w-full overflow-x-auto" tour-step-2>
           <div class="flex space-x-4 tablet:space-x-2 items-center tablet:grid tablet:grid-flow-col mobile:justify-between">
               <navigation-bar-item icon="fa-building" :sub-page="SubPage.GENERAL" :title="translate('algemeen')"></navigation-bar-item>
               <navigation-bar-item icon="fa-user-tie" :sub-page="SubPage.DIRECTORS" :title="translate('bedrijfsleiding')" :badge="detailStore.aantalHuidigeBedrijfsleiding"></navigation-bar-item>
               <navigation-bar-item icon="fa-diagram-subtask" :sub-page="SubPage.PARTICIPATIONS" :title="translate('bedrijfsstructuur')" :is-disabled="!detailStore.hasParticipations"></navigation-bar-item>
               <navigation-bar-item icon="fa-map-marker-alt" :sub-page="SubPage.LOCATIONS" :title="translate('locations')" :badge="detailStore.aantalVestigingen"></navigation-bar-item>
               <navigation-bar-item icon="fa-timeline" :sub-page="SubPage.TIMELINE" :title="translate('timeline')"></navigation-bar-item>
               <navigation-bar-item icon="fa-shield-check" :sub-page="SubPage.KYC" :is-disabled="!detailStore.isBelgian" title="KYC" hide-on-mobile></navigation-bar-item>
               <navigation-bar-item icon="fa-balance-scale" :sub-page="SubPage.FINANCIAL_STATEMENTS" :title="translate('jaarrekeningen')"></navigation-bar-item>
           </div>
       </div>
   </nav>
</template>

<script lang="ts">
import {SubPage} from "../types";
import {useDetailStore} from '../store';
import {defineComponent} from 'vue';
import NavigationBarItem from "./navigation-bar-item.vue";

export default defineComponent({
    name: "navigation-bar",
    components: {NavigationBarItem},
    data() {
        return {
            SubPage,
            detailStore: useDetailStore()
        }
    }
});
</script>